import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";

function Loader(props) {
  return (
    <>
      <Spin
        spinning={props.isLoading}
        className="mx-2"
        indicator={<LoadingOutlined spin style={{ color: "white" }} />}
        size="small"
      />
    </>
  );
}

export default Loader;
